import { ContentObjectItem } from "@vertesia/common"
import { Box, Calendar, User, X } from "lucide-react"

import { DocumentOverlay } from "@/components/overlays/DocumentOverlay"
import { Badge } from "@ui/badge"
import { Button } from "@ui/button"
import { useUserCache } from "@hooks/useUserCache"
import { useUserSession } from "@session/UserSession"

interface SimplifiedDocumentCardProps {
    object: ContentObjectItem
    onRemoveFromSelection: (doc: ContentObjectItem) => void
}
export function SimplifiedDocumentCard({ object, onRemoveFromSelection }: Readonly<SimplifiedDocumentCardProps>) {
    const { client } = useUserSession()
    const { getUserDisplayName } = useUserCache(client)

    return (
        <DocumentOverlay document={object.id}>
            <div className="flex flex-col gap-2 p-2 border rounded cursor-pointer bg-blue-50 border-blue-200 w-full">
                <div className="flex items-center gap-3 w-full">
                    <div className="flex-1 min-w-0">
                        <h4 className="font-semibold truncate" title={object.name}>
                            {object.name}
                        </h4>
                    </div>
                    <div className="flex items-center gap-1 flex-shrink-0">
                        <Badge className="whitespace-nowrap">
                            {object.type?.name || "Document"}
                        </Badge>
                        <Button size={"xs"} variant={"ghost"} onClick={(e) => { e.stopPropagation(); onRemoveFromSelection(object) }}>
                            <X />
                        </Button>
                    </div>
                </div>
                <div className='flex flex-row gap-6 items-center text-sm text-gray-500'>
                    <div className="flex flex-row gap-1 items-center text-xs text-gray-400">
                        <User className='h-3 w-3' />
                        {getUserDisplayName(object.created_by, "AI Report Generator")}
                    </div>
                    <div className="flex flex-row gap-1 items-center text-xs text-gray-400">
                        <Calendar className='h-3 w-3' />
                        {new Date(object.created_at).toLocaleDateString()}
                    </div>
                    <div className="flex flex-row gap-1 items-center text-xs text-gray-400">
                        <Box className='h-3 w-3' />
                        {object?.content?.type || "Unknown"}
                    </div>
                </div>
                <div>
                    {
                        object?.tags?.map((tag, index) => (
                            <span key={index} className="inline-block mt-1 mr-2 px-2 py-1 text-xs bg-gray-100 text-gray-700 rounded">
                                {tag}
                            </span>
                        ))
                    }
                </div>
            </div>
        </DocumentOverlay>
    )
}